import { useModal } from "ui/atoms/Modal";
import { ApplicationTableResourceContext } from "./types";

export const useApplicationTableResource = () => useModal<ApplicationTableResourceContext>();

export default useApplicationTableResource;
